import { Observable } from 'rxjs';
import { ApiHttpClient } from './../../../http/clients/api';
import { Injectable } from '@angular/core';
import { Funnel } from './../models/funnel.model';
import { FunnelUsers } from '../models/funnel-users';

/**
 * Get funnels from the API.
 */
@Injectable({
  providedIn: 'root'
})
export class FunnelService {
    baseUrl = '/funnel/';

    /**
     * @param http - Injected http client service.
     */
    constructor(
      private http: ApiHttpClient
    ) {}

    /**
     * Get a sales funnel for a funding manager.
     *
     * @param lenderUserId - Lender user ID.
     * @returns Http response as Observable<Funnel>.
     */
    getFundingManagerFunnel(lenderUserId: number): Observable<Funnel> {
      return this.http.get<Funnel>(this.baseUrl + 'funding-manager/' + lenderUserId);
    }

    /**
     * Get a funnel for a funding desk team.
     *
     * @param lenderUserId - Lender user ID.
     * @returns Http response as Observable<Funnel>.
     */
    getFundingDeskFunnel(lenderUserId: number): Observable<Funnel> {
      return this.http.get<Funnel>(this.baseUrl + 'funding-desk/' + lenderUserId);
    }

    /**
     * Get a funding desk funnel users.
     *
     * @returns Http response as Observable<[]>.
     */
    getFundingDeskFunnelUsers(): Observable<FunnelUsers[]> {
      return this.http.get<FunnelUsers[]>(this.baseUrl + 'fd-users/');
    }
}
